var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{attrs:{"no-body":""}},[_vm._l((_vm.groupedWidgetList),function(item){return [_c('WidgetList',{attrs:{"add-widget-list":_vm.addWidgetList,"widget-list":item.widgets},on:{"updateAddList":_vm.updateAddList}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }